import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Glide from '@glidejs/glide';
import Svg from 'rp-react-svg-icon';

class Slider extends PureComponent {
    componentDidMount() {
        this.slider.mount();
    }

    componentDidUpdate() {
        this.slider.mount();
    }

    showControls() {
        const { slides } = this.props;

        return slides && Array.isArray(slides) && slides.length > 1;
    }

    renderControls() {
        const { slides, hideArrows } = this.props;

        if (!this.showControls()) {
            return null;
        }

        return (
            <div className="glide__controllers-wrapper">
                {!hideArrows && (
                    <div className="glide__arrows" data-glide-el="controls">
                        <button
                            className="glide__arrow glide__arrow--left"
                            data-glide-dir="<"
                        >
                            <Svg
                                iconName="left"
                                className="ui-icon chevronIcon"
                                size="Large"
                            />
                        </button>
                    </div>
                )}

                <div className="glide__bullets" data-glide-el="controls[nav]">
                    {
                        slides.map((slide, i) => (
                            <button
                                key={slide.sequence}
                                className="glide__bullet"
                                data-glide-dir={`=${i}`}
                            />
                        ))
                    }
                </div>

                {!hideArrows && (
                    <div className="glide__arrows" data-glide-el="controls">
                        <button
                            className="glide__arrow glide__arrow--right"
                            data-glide-dir=">"
                        >
                            <Svg
                                iconName="right"
                                className="ui-icon chevronIcon"
                                size="Large"
                            />
                        </button>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { slides } = this.props;
        this.slider = new Glide('.glide');

        return (
            <div className={`glide${(!this.showControls() ? ' glide--no-controls' : '')}`}>
                <div className="glide__track" data-glide-el="track">
                    <ul className="glide__slides">
                        {
                            slides.map(slide => (
                                <li
                                    key={slide.sequence}
                                    className="glide__slide"
                                    style={{
                                        backgroundImage: `url("${slide.url}")`,
                                    }}
                                />
                            ))
                        }
                    </ul>
                </div>

                {this.renderControls()}
            </div>
        );
    }
}

Slider.propTypes = {
    hideArrows: PropTypes.bool,
    slides: PropTypes.oneOfType([
        PropTypes.arrayOf({
            sequence: PropTypes.number,
            alt: PropTypes.string,
            contenttype: PropTypes.string,
            mediatype: PropTypes.string,
            url: PropTypes.string,
        }),
        PropTypes.array,
    ]),
};

export default Slider;



// WEBPACK FOOTER //
// ./src/js/shared/Slider.jsx